import React from 'react';
import { motion } from 'framer-motion';
import CSRPartners from '../components/CSRPartners';

const CSRPage = () => {
  return (
    <div className="pt-16">
      <section className="py-20 bg-gray-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">CSR Partnership</h1>
            <p className="text-xl text-gray-600">
              Partner with us to create meaningful social impact through your CSR initiatives
            </p>
          </motion.div>
        </div>
      </section>
      <CSRPartners />
    </div>
  );
};

export default CSRPage;